/**
 * @typedef {Object} Choice
 * @property {string} value
 * @property {string} title
 */
import {
  IPA_PRODUCT_TYPES,
  INSULATION_VARIANTS,
  GROOVED_PANEL_SIZE,
  TACKER_PANEL_SIZE,
  TACKER_FOIL
} from "./IPAProducts";

/**
 * Insulation types
 * @type {Choice[]}
 */
export const INSULATION_TYPES = [
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.GROOVED, size: GROOVED_PANEL_SIZE.DIM_10MM },
    title: "Panou cu nuturi 11mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.GROOVED, size: GROOVED_PANEL_SIZE.DIM_20MM },
    title: "Panou cu nuturi 20mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.GROOVED, size: GROOVED_PANEL_SIZE.DIM_30MM },
    title: "Panou cu nuturi 30mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.GROOVED, size: GROOVED_PANEL_SIZE.DIM_SYSTEM_REDUCED },
    title: "Panou cu nuturi redus 5mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.TACKER, size: 20 },
    title: "Placa Tacker 20mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.TACKER, size: 30 },
    title: "Placa Tacker 30mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.TACKER, size: 50 },
    title: "Placa Tacker 50mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.TACKER, size: 25 },
    title: "Rola Tacker 25mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.DRY },
    title: "EPS - Sistem uscat"
  }
];
  
  // Additional insulation (keep it the same enum schema: INSULATION + TACKER + thickness)
export const ADDITIONAL_INSULATION_TYPES = [
   {
    value: 0,
    title: "-----",
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.ADDITIONAL_TACKER, size: TACKER_PANEL_SIZE.THK_20 },
    title: "Placă Tacker 20mm"
  },
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.ADDITIONAL_TACKER, size: TACKER_PANEL_SIZE.THK_30 },
    title: "Placă Tacker 30mm"
  },
 
  {
    value: { type: IPA_PRODUCT_TYPES.INSULATION, subtype: INSULATION_VARIANTS.ADDITIONAL_TACKER, size: TACKER_PANEL_SIZE.THK_50 },
    title: "Placă Tacker 50mm"
  }
];

// Tacker foil choices (value is a pure enum number)
export const TACKER_FOIL_TYPES = [
  { value: TACKER_FOIL.NONE,      title: "--------" },
  { value: TACKER_FOIL.SIMPLE,    title: "Simplă" },
  { value: TACKER_FOIL.ALUMINIUM, title: "Cu aluminiu" },
];